module.exports = __webpack_public_path__ + "static/img/jingyin.c493611.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/jingyin.png
// module id = qnGr
// module chunks = 24